import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'rk-platform-publishing-shell',
  imports: [],
  templateUrl: './platform-publishing-shell.component.html',
  styleUrl: './platform-publishing-shell.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class PlatformPublishingShellComponent {}
